import { useQuery } from "@tanstack/react-query";
import { insightsApi } from "../api/insights";

const PRIORITY_COLORS: Record<string, string> = {
  high: "border-rose-300 bg-rose-50",
  medium: "border-amber-300 bg-amber-50",
  low: "border-slate-200 bg-slate-50",
};

export default function Insights() {
  const { data, isLoading } = insightsQuery();
  return (
    <div className="space-y-4">
      <h2 className="text-lg font-semibold text-slate-900">Insights</h2>
      {isLoading && <div className="text-slate-500">Loading…</div>}
      {data && data.length === 0 && (
        <div className="rounded border border-slate-200 bg-white p-4 text-sm text-slate-500">
          No insights yet. Once events flow in, the rules engine will surface adoption gaps, error
          spikes, cost concentration, and more.
        </div>
      )}
      <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
        {data?.map((i) => (
          <div
            key={i.id}
            className={`rounded-lg border p-4 ${PRIORITY_COLORS[i.priority] ?? ""}`}
          >
            <div className="mb-1 flex items-center gap-2">
              <span className="rounded bg-white px-2 py-0.5 text-xs font-medium uppercase tracking-wide text-slate-600">
                {i.priority}
              </span>
              <span className="text-xs text-slate-500">{i.rule_id}</span>
            </div>
            <div className="text-sm font-semibold text-slate-900">{i.title}</div>
            <div className="mt-1 text-sm text-slate-700">{i.body}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

function insightsQuery() {
  return useQuery({ queryKey: ["insights"], queryFn: insightsApi.list });
}
